import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  Paper,
  FormControl,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useRef, useState } from "react";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ConfirmationDialog from "../../../common/ConfirmationDialog";
import { PlayerProfileService } from "../../../services/playerProfile.Service";
import AppConstatnts from "../../../common/AppConstants";
import DataGridCustom from "../../../sharedComponents/dataGrid/DataGridCustom";
import Loader from "../../../sharedComponents/loader/loader";
import TitleTooltip from "../../../sharedComponents/Tooltip/TitleTooltip";
import { getInputBox } from "../../../sharedComponents/formFields/LabelInFormFields";
import { useContext } from "react";
import AppDataContext from "../../../common/appContext";

const GLeagueExperienceViewUpdate = ({
  eventId,
  playerID,
  gridPropsData,
  styles,
  viewProfile,
  setAlert,
  setAlertType,
  setAlertMessage,
  //   user,
}) => {
  const useStyles = makeStyles((theme) => styles);
  const classes = useStyles();
  const { user } = useContext(AppDataContext);
  const formData = {
    id: 0,
    playerID: playerID,
    eventId: eventId,
    years: "",
    team: "",
    contact: "",
    phone: "",
    userBy: user?.loginID,
    mode: null,
  };
  const defaultErrors = {
    years: false,
  };
  const defaultErrorMsg = {
    years: "",
  };
  const [gLeagueGridData, setGLeagueGridData] = useState([]);
  const [gLeagueFormData, setGLeagueFormData] = useState({});
  const [openConfirmationBox, setOpenConfirmationBox] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [deletedRowID, setDeletedRowId] = useState(-1);
  const [error, setError] = useState(defaultErrors);
  const [errorMessage, setErrorMessage] = useState(defaultErrorMsg);

  const [columnFlex, setColumnFlex] = useState(
    window.innerWidth >= 1570 ? 1 : "none"
  );
  const columns = [
    { field: "id", hide: true, flex: 1 },
    {
      field: "years",
      headerName: "G League Year",
      width: 150,
      flex: columnFlex,
    },
    {
      field: "team",
      headerName: "Team",
      width: 150,
      flex: columnFlex,
    },
    {
      field: "contact",
      headerName: "Team Contact",
      width: 150,
      flex: columnFlex,
    },
    {
      field: "phone",
      headerName: "Team Contact Phone",
      width: 180,
      flex: columnFlex,
    },
  ];

  useEffect(() => {
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);

  useEffect(() => {
    setGLeagueGridData(gridPropsData);
    setGLeagueFormData(formData);
  }, [gridPropsData]);

  //---UTILs---

  const onResize = () => {
    setColumnFlex(window.innerWidth >= 1570 ? 1 : "none");
  };

  const toggleAlert = (open, type, message) => {
    setAlert(open);
    setAlertType(type);
    setAlertMessage(message);
  };

  const toggleError = (key, val, message) => {
    setError({ ...error, [key]: val });
    setErrorMessage({ ...errorMessage, [key]: message });
  };

  const resetError = () => {
    setError(defaultErrors);
    setErrorMessage(defaultErrorMsg);
  };

  const validateErrors = () => {
    let valid = true;
    Object.keys(error).forEach((key) => {
      valid = valid && !error[key];
    });
    if (!valid) {
      toggleAlert(true, "warning", "Please correct the invalid fields.");
    }
    return valid;
  };

  const checkIfSaveBtnDisabled = () => {
    return gLeagueFormData.team ||
      gLeagueFormData.years ||
      gLeagueFormData.contact ||
      gLeagueFormData.phone
      ? false
      : true;
  };

  //---HANDLERS---

  //single handler to open and close delete confirmation dialog box
  const handleOpenCloseConfirmationBox = (val) => {
    if (val === false) {
      setDeletedRowId(-1);
    }
    setOpenConfirmationBox(val);
  };

  //1. find the GLeague details to edit from grid data
  //2. set the input boxes with GLeague details to edit
  //3. set userBy to current user -- for DB record
  const handleRowEditClick = (id) => {
    resetError();
    setIsUpdate(true);
    let result = gLeagueGridData.find((g, i) => {
      return g.id === id;
    });
    setGLeagueFormData({ ...result, userBy: user?.loginID });
  };

  const handleRowDeleteClick = (id) => {
    setDeletedRowId(id);
    handleOpenCloseConfirmationBox(true);
  };

  //reset the input boxes with initially declared empty formData
  const handleCancelUpdate = () => {
    resetError();
    setIsUpdate(false);
    setGLeagueFormData(formData);
  };

  //common input change handler from TEXTBOX input
  const handleInputChange = (e, key) => {
    let value = e.target.value;
    let defaultVal = "";
    switch (key) {
      case "years":
        if (
          value &&
          !value.toLowerCase().match(AppConstatnts.VALIDATIONS.YEAR_REGEX)
        )
          toggleError(key, true, "Invalid Year");
        else toggleError(key, false, "");
        break;
    }
    setGLeagueFormData({
      ...gLeagueFormData,
      [key]: value || defaultVal,
    });
  };

  //1. validate then call api to save
  //2. after save reset necessary values
  const handleSaveClick = () => {
    if (!checkIfSaveBtnDisabled() && validateErrors()) {
      const result = handleSubmit(gLeagueFormData);
      if (result) {
        handleCancelUpdate();
        toggleAlert(true, "success", "Data uploaded successfully.");
      }
    }
  };

  //1. find the record to delete from grid data
  //2. set the mode to "delete" --- for DB
  //3. after delete reset necessary values
  const handleDeleteClick = () => {
    let record = gLeagueGridData.find((g, i) => {
      return g.id === deletedRowID;
    });
    if (record) {
      const updatedForm = {
        ...record,
        mode: "delete",
        userBy: user.loginID,
      };
      const result = handleSubmit(updatedForm);
      if (result) {
        handleCancelUpdate();
        handleOpenCloseConfirmationBox(false);
        toggleAlert(
          true,
          "success",
          "GLeague experience record deleted Successfully."
        );
      }
    }
  };

  //---APIs---
  //to create, update or delete a record -- common api
  const handleSubmit = async (formData) => {
    setIsLoading(true);
    try {
      const result =
        await PlayerProfileService.insertUpdateGLeagueExperienceDetails(
          formData
        );
      if (result) {
        getUpdatedGLeagueGridData();
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
      toggleAlert(true, "error", "Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };

  //get updated records after creating, updating or deleting record, for view
  const getUpdatedGLeagueGridData = async () => {
    try {
      const result = await PlayerProfileService.getPlayersProfileData(
        playerID,
        eventId,
        user?.loginID
      );
      setGLeagueGridData(result.data.gLeagueExperience);
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <>
      {isLoading && <Loader isLoading={isLoading}></Loader>}
      <Paper square elevation={5} className={classes.paperStyle}>
        <Grid container>
          <Grid
            item
            lg={10}
            md={10}
            sm={10}
            xs={10}
            className={classes.sectionTitlePadding}
          >
            <Typography
              noWrap
              variant="subtitle1"
              fontWeight="medium"
              color="secondary"
            >
              G League Experience
            </Typography>
          </Grid>
          {!viewProfile ? (
            <Grid
              item
              lg={2}
              md={2}
              sm={2}
              xs={2}
              className={classes.inputSectionPadding}
            >
              <Box>
                {isUpdate ? (
                  <Button
                    className={classes.cancelButton}
                    size={classes.submitButtonSize}
                    variant={styles.cancelButton.variant}
                    title={styles.cancelButton.title}
                    onClick={handleCancelUpdate}
                  >
                    <TitleTooltip title="cancel">
                      <CancelOutlinedIcon
                        sx={{ color: styles.cancelButton.cancelIconColor }}
                      />
                    </TitleTooltip>
                  </Button>
                ) : (
                  ""
                )}
                <Button
                  className={classes.saveButton}
                  size={classes.submitButtonSize}
                  variant={styles.saveButton.variant}
                  title={styles.saveButton.title}
                  disabled={checkIfSaveBtnDisabled()}
                  onClick={handleSaveClick}
                >
                  <TitleTooltip title="Save GLeague details">
                    <SaveOutlinedIcon />
                  </TitleTooltip>
                </Button>
              </Box>
            </Grid>
          ) : (
            ""
          )}
        </Grid>
        {!viewProfile ? (
          <Grid
            key={0}
            container
            pl={2}
            pr={2}
            spacing={2}
            justifyContent={"start"}
          >
            <Grid item lg={3} md={6} sm={12} xs={12}>
              {getInputBox(
                "G League Year",
                gLeagueFormData.years,
                (e) => handleInputChange(e, "years"),
                false,
                "text",
                error.years
                // errorMessage.years
              )}
            </Grid>
            <Grid item lg={3} md={6} sm={12} xs={12}>
              {getInputBox("Team", gLeagueFormData.team, (e) =>
                handleInputChange(e, "team")
              )}
            </Grid>
            <Grid item lg={3} md={6} sm={12} xs={12}>
              {getInputBox("Team Contact", gLeagueFormData.contact, (e) =>
                handleInputChange(e, "contact")
              )}
            </Grid>
            <Grid item lg={3} md={6} sm={12} xs={12}>
              {getInputBox("Team Contact Phone", gLeagueFormData.phone, (e) =>
                handleInputChange(e, "phone")
              )}
            </Grid>
          </Grid>
        ) : (
          ""
        )}
        <Grid item xs={12} className={classes.dataGridPadding}>
          <DataGridCustom
            classes={classes}
            styles={styles}
            columns={columns}
            rows={gLeagueGridData}
            viewProfile={viewProfile}
            handleRowEditClick={handleRowEditClick}
            handleRowDeleteClick={handleRowDeleteClick}
          />
          <ConfirmationDialog
            keepMounted
            open={openConfirmationBox}
            onClose={() => handleOpenCloseConfirmationBox(false)}
            onSubmit={handleDeleteClick}
          />
        </Grid>
      </Paper>
    </>
  );
};

export default React.memo(GLeagueExperienceViewUpdate);